var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DocumentViewIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '16' : _b, _c = _a.height, height = _c === void 0 ? '16' : _c;
    return (_jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M1.173 8.445C1.066 8.164 1.066 7.836 1.173 7.555C2.303 4.653 5.033 2.5 8 2.5C10.967 2.5 13.697 4.653 14.827 7.555C14.934 7.836 14.934 8.164 14.827 8.445C13.697 11.347 10.967 13.5 8 13.5C5.033 13.5 2.303 11.347 1.173 8.445Z", stroke: "#6B7280", strokeWidth: "1.25", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("circle", { cx: "8", cy: "8", r: "2.25", stroke: "#6B7280", strokeWidth: "1.25", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
